<template>
  <div class="float-module">
    <img class="image" :src="moduleData.img_url">
    <div class="float-module float-module-btns">
      <div v-for="(item, index) in moduleData.btnList" :key="index" class="btn-item" @click="showModal(item, index)"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    moduleData: {
      type: Object
    }
  },
  methods: {
    showModal(item, index) {
      this.$emit('consult', { ...item, btnId: `0${index + 1}` });
    }
  }
}
</script>

<style lang="less" scoped>
.float-module {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 7.5rem;
  height: 1.72rem;
  z-index: 3;
  .float-module-btns {
    display: flex;
    .btn-item {
      flex: 1;
    }
  }
}

.image {
  width: 7.5rem;
  height: 1.72rem;
  cursor: pointer;
}

</style>


// WEBPACK FOOTER //
// src/components/modules/content-float.vue